/**
 * Returns result that input string is json
 *
 * @param {string} string
 * @returns {boolean}
 */
export default function isJSONString(string = '') {
    const str = string && typeof string === 'string'
        ? string.trim()
        : '';
    if (!str) {
        return false;
    }
    try {
        const data = JSON.parse(str);
        return typeof data === 'object' && data !== null;
    } catch (e) {
        return false;
    }
}
